<template>
    <div class="packlist-header">
        <div class="packlist-header-content">
            <div class="packlist-header-upsell-and-timer">
                <div class="packlist-header-upsell-and-carton">
                    <CartonItem
                        v-if="currentCarton"
                        :currentCarton="currentCarton" 
                    />
                    <UpsellItems 
                        :upsellItems="upsellItems"
                        :currentFlyer="currentFlyer"
                    />
                </div>
                <Timer :currentPackstats="currentPackstats" layout="compact" />
            </div>
            <div class="packlist-header-packlist-info">
                <div class="packlist-header-order-id-and-customer-info">
                    <v-chip
                        color="primary"
                        small
                        class="order-id-chip"
                    >
                        <span class="packlist-header-order-id">{{ currentOrderId }}</span>
                    </v-chip>
                    <v-chip
                        color="grey"
                        small
                        outlined
                    >
                        <v-icon left small>mdi-package-variant</v-icon>
                        Offen - {{ openItems.length }}
                    </v-chip>
                    <div class="packlist-header-customer-info" :class="{ 'customer-info-stacked': shouldStackCustomerInfo }">
                        <span class="packlist-header-customer-name">{{ currentOrder?.customer?.firstName }} {{ currentOrder?.customer?.lastName }}</span>
                        <span v-if="!shouldStackCustomerInfo" class="separator">-</span>
                        <span class="packlist-header-customer-address">{{ currentOrder?.customer?.adress }}</span>
                    </div>
                </div>
                <v-btn
                    color="error"
                    @click="openProblemModal"
                    :class="{ 'problem-btn-tablet': shouldStackCustomerInfo }"
                >
                    Problem melden
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import PacklistItems from './PacklistItems.vue'
import CartonItem from './CartonItem.vue'
import UpsellItems from './UpsellItems.vue'
import Timer from './Timer.vue'
export default {
    name: 'PacklistHeader',
    components: {
        PacklistItems,
        UpsellItems,
        Timer,
        CartonItem
    },
    data() {
        return {
            windowWidth: window.innerWidth
        }
    },
    props: {
        currentOrderId: {
            type: String,
            default: null
        },
        currentOrder: {
            type: Object,
            default: () => {}
        },
        currentFlyer: {
            type: Object,
            default: () => null
        },
        openItems: {
            type: Array,
        },
        packedItems: {
            type: Array,
            default: () => []
        },
        pausedItems: {
            type: Array,
            default: () => []
        },
        upsellItems: {
            type: Array,
            default: () => []
        },
        currentFlyer: {
            type: Object,
            default: () => null
        },
        currentPackstats: {
            type: Object,
            default: () => ({
                progress: 0,
                targetProgress: 40,
                count: 0,
                time: 0
            })
        },
        currentCarton: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        shouldStackCustomerInfo() {
            // Stack customer info when:
            // 1. On tablet (768px - 1199px)
            // 2. Or when width is too small (< 600px for mobile)
            return this.windowWidth < 1200;
        }
    },
    methods: {
        handleItemClick(item) {
            this.$emit('packlist-item-click', item);
        },
        openProblemModal() {
            this.$emit('open-problem-modal');
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style>
.packlist-header {
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #e0e0e0;
}

.packlist-header-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 2px;
}

.packlist-header-upsell-and-carton {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 12px;
}

.packlist-header-upsell-and-timer {
    display: flex;
    justify-content: space-between;
}

.packlist-header-packlist-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.packlist-header-order-id-and-customer-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.order-id-chip {
    flex-shrink: 0;
}


.packlist-header-order-id {
    font-size: 1.2rem;
    font-weight: 600;
}

.packlist-header-customer-info {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

/* Stacked customer info layout */
.packlist-header-customer-info.customer-info-stacked {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
}

.packlist-header-customer-name {
    font-size: 1.2rem;
    font-weight: 600;
}

.packlist-header-customer-address {
    font-size: 1.1rem;
    color: #666;
}

.separator {
    color: #999;
    font-weight: normal;
}

/* Problem button adjustments for tablet */
.problem-btn-tablet {
    align-self: flex-start;
    margin-top: 6px;
}

/* Mobile responsive adjustments */
@media (max-width: 767px) {
    .packlist-header-content {
        padding: 10px;
    }

    .packlist-header-order-id {
        font-size: 1.1rem;
    }

    .packlist-header-customer-name {
        font-size: 1.1rem;
    }

    .packlist-header-customer-address {
        font-size: 1rem;
    }
}
</style>